import { Box, Card, CardContent, Typography } from '@mui/material';
import LoadingAnimation from '../../../../reusable-components/loader/LoadingAnimation';

export default function RestrictedDates() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card sx={{ m: 3, p: 3 }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography textAlign="center" variant="subtitle1" color="text.secondary">
            The restricted dates page is still being worked on, please check back later!
          </Typography>
          <LoadingAnimation />
        </CardContent>
      </Card>
    </Box>
  );
}
